

export const customTableColumns = [
  {
    Header: 'Codigo de usuario',
    accessor: 'username',
  },
  {
    Header: 'Nombre',
    accessor: 'first_name',
  },
  {
    Header: 'Apellido',
    accessor: 'last_name',
  },
  {
    Header: "Correo electrónico",
    accessor: 'email',
  }
];

